import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.ContactForm = class ContactForm extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-contact-form';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.addEventListeners();
    }

    setVars() {
        this.$form = this.$element.find('.fa-contact-form__form');
        this.$messageContainer = this.$element.find('.message-container');
        this.errorClass = 'fa-input-field--error';
        this.messageClass = 'fa-input-field__error-message';
    }

    addEventListeners() {
        this.$form.on('submit', this.onFormSubmission.bind(this));
    }

    onFormSubmission(event) {
        event.preventDefault();

        $.ajax({
            url: this.formAction = this.$form.attr('action'),
            method: this.formMethod = this.$form.attr('method'),
            data: this.formData = this.$form.serialize()
        })
        .always(this.handleValidationResponse.bind(this));
    }

    handleValidationResponse(response) {
        console.log(response);
        if (!response.success) {
            $.each(response.fields, (i, field) => {
                if (!field.success) {
                    this.showValidationError(field);
                } else {
                    this.removeValidationError(field);
                }
            });
        } else {
            this.handleSuccess(response);
        }
    }

    showValidationError(field) {
        const $element = this.$form.find(`[name=${field.element}]`);

        $element
        .addClass(this.errorClass)
        .parent()
        .addClass(this.errorClass)
        .find(`.${this.messageClass}`).text(field.message);
    }

    removeValidationError(field) {
        const $element = this.$form.find(`[name=${field.element}]`);

        $element
        .removeClass(this.errorClass)
        .parent()
        .removeClass(this.errorClass)
        .find(`.${this.messageClass}`).text('');
    }

    handleSuccess(response) {
        const activeClass = 'active';

        this.resetForm();
        this.$messageContainer.addClass(activeClass);

        // commented code below didn't work so now it's commented and is to be removed
        // $.each(response.fields, (i, field) => {
        //     this.removeValidationError(field);
        // });

        window.setTimeout(function() {
            this.$messageContainer.removeClass(activeClass);
        }.bind(this), 10000);

        if (this.$body.hasClass('cfa-generic')) {
            $(window).trigger('gtm:send', [ 'Contact Us', 'Submit', 'Submit an enquiry']);
        }
    }

    resetForm() {
        this.$form.find('input, select, textarea').each((i, element) => {
            element.value = '';
            $(element)
            .removeClass(this.errorClass)
            .parent()
            .removeClass(this.errorClass)
            .find(`.${this.messageClass}`).text('');
        });
    }
};



// WEBPACK FOOTER //
// ./components/contactForm/scripts/contactForm.js